'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _LinkButton = require('../../../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var mapStateToProps = function mapStateToProps(state) {
    return {
        email: state.getIn(['app', 'currentUser', 'email'])
    };
};

// Components


var UserEmailReadOnly = function UserEmailReadOnly(_ref) {
    var email = _ref.email,
        toggleEditable = _ref.toggleEditable;
    return _react2.default.createElement(
        'div',
        { className: 'UserNameReadOnly' },
        _react2.default.createElement(
            'span',
            null,
            email
        ),
        _react2.default.createElement(
            _LinkButton2.default,
            { onClickFn: toggleEditable },
            'Change'
        )
    );
};

UserEmailReadOnly.propTypes = {
    email: _propTypes2.default.string,
    toggleEditable: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UserEmailReadOnly);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/editableUserEmail/UserEmailReadOnly.js
// module id = 2088
// module chunks = 0